// extracted by mini-css-extract-plugin
module.exports = {"disabled":"BannersScreen_disabled__WKU6k"};